import { useQuery } from '@tanstack/react-query';
import { getExpressionParamWithData } from 'config/requests/gatewayRules';
import { ExpressionParamWithData } from 'types/embedded/gatewayRule';

export type UseExpressionParamWithDataReturnValue = {
  expressionParamWithData: ExpressionParamWithData | undefined;
  loadingExpressionParamWithData: boolean;
};

export function useExpressionParamWithData(
  expressionAlias: string,
): UseExpressionParamWithDataReturnValue {
  const { data: expressionParamWithData, isLoading: loadingExpressionParamWithData } =
    useQuery<ExpressionParamWithData>({
      queryKey: ['expression_param_with_data', expressionAlias],
      queryFn: () => getExpressionParamWithData(expressionAlias),
      enabled: !!expressionAlias,
    });

  return { expressionParamWithData, loadingExpressionParamWithData };
}
